import React from "react";
//components
import Modal from "../../../../components/modal/Modal";
import { Button } from "primereact/button";

const ModalDownload = ({ visible, onHide, rowData }) => {
  const onClickDownload = async (type) => {
    if (type === 1 && rowData.pdf) {
      window.open(rowData.pdf, "_blank");
      return;
    }
    if (type === 2 && rowData.txt) {
      try {
        const response = await fetch(rowData.txt);
        if (!response.ok) throw new Error("Falha ao baixar o TXT");

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "file.txt";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(blobUrl);
      } catch (err) {
        console.error("Erro ao tentar fazer download do TXT:", err);
      }
    }
  };

  return (
    <Modal
      visible={visible}
      dynamicTitle={"Escolha o tipo de download"}
      onHide={onHide}
      closable={true}
    >
      <div className="row p-2 modal-switch">
        <div className="col-md-6 my-2">
          <div
            onClick={() => onClickDownload(1)}
            className={`card card-animation d-flex align-items-center p-5`}
            style={{ borderRadius: "15px" }}
          >
            <h1 style={{ fontSize: "50px" }}>
              <i className="fa-solid fa-file text-danger"></i>
            </h1>
            <h2>PDF</h2>
          </div>
        </div>
        <div className="col-md-6 my-2">
          <div
            onClick={() => onClickDownload(2)}
            className={`card card-animation d-flex align-items-center p-5`}
            style={{ borderRadius: "15px" }}
          >
            <h1 style={{ fontSize: "50px" }}>
              <i className="fa-solid fa-file-lines"></i>
            </h1>
            <h2>TXT</h2>
          </div>
        </div>
      </div>
      <div className="row justify-content-center p-2">
        <div className="col-md-3">
          <Button 
            rounded
            label="Concluído"
            icon="fa-solid fa-check"
            onClick={onHide}
            className="w-100"
          />
        </div>
      </div>
    </Modal>
  );
};

export default ModalDownload;
